import React from 'react'
import {Image} from '@/components/image'
import useMediaQuery from 'hec/hooks/useMediaQuery'
import {useMediaQueryWithBuilder} from 'hec/builder/hooks/useMediaQueryWithBuilder'
import {TextBlock} from '@/components/text-block'
import {getHeroBgStyle} from '../utils'
import {IthreeColumnProps} from '../types'
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    ContentButtonNavigation
} from '@/components/ui/carousel'

const ThreeColumn = (props: IthreeColumnProps) => {
    const {isMobile: isBuilderMobile} = useMediaQueryWithBuilder()
    const isMobile = useMediaQuery('sm')
    const {
        backgroundType,
        backgroundImage,
        backgroundImageMobile,
        backgroundColor,
        backgroundGradient,
        leftImage,
        rightImage,
        mobileImageLeft,
        mobileImageRight,
        external,
        external_link,
        link,
        couponCode,
        enableCouponCode,
        eyebrowText,
        eyebrowIcon,
        eyebrowType,
        disclaimerText,
        headlineType,
        headlineImage,
        headlineText,
        textBlock,
        callToAction,
        buttonColor,
        enableOverlay,
        overlayColor,
        textAlignment,
        eyebrowBackgroundColor,
        eyebrowSize,
        eyebrowTextColor,
        carouselItems = [],
        carouselAutoplay,
        carouselAutoplayDelay,
        carouselDots
    } = props
    const resolvedLink = external
        ? external_link?.value?.data?.url ?? ''
        : link?.value?.data?.url ?? ''
    resolvedLink == '' && console.error('No link provided for ThreeColumn component')

    const bgStyle = getHeroBgStyle({
        backgroundType,
        backgroundImage,
        backgroundImageMobile,
        backgroundColor,
        backgroundGradient,
        isMobile,
        isBuilderMobile
    })

    return backgroundType === 'carousel' ? (
        <Carousel
            opts={{
                align: 'start',
                loop: true
            }}
            autoplay={carouselAutoplay}
            autoplayDelay={carouselAutoplayDelay || 4000}
            stopOnInteraction={true}
            className="w-full"
        >
            <CarouselContent>
                {carouselItems.map((item, index) => {
                    const carouselBgStyle = getHeroBgStyle({
                        backgroundType: item.carouselBackgroundType || 'image',
                        backgroundImage: item.backgroundImage,
                        backgroundImageMobile: item.backgroundImageMobile,
                        backgroundColor: item.backgroundColor,
                        backgroundGradient: item.backgroundGradient,
                        isMobile,
                        isBuilderMobile
                    })

                    const carouselResolvedLink = item.external
                        ? item.external_link?.value?.data?.url ?? ''
                        : item.link?.value?.data?.url ?? ''

                    return (
                        <CarouselItem key={index}>
                            <div
                                className="hero hero-three-col flex flex-col relative pb-8 pt-8"
                                style={carouselBgStyle}
                            >
                                {!isMobile && !isBuilderMobile ? (
                                    <div className="flex flex-row gap-8 ml-auto mr-auto w-full ">
                                        <div className="grid grid-cols-12 gap-8 ml-auto mr-auto w-full  items-center">
                                            <div className="col-span-3 flex justify-center">
                                                <Image src={item.leftImage} alt="Left Image" />
                                            </div>
                                            <div className="col-span-6 flex flex-col justify-center items-center text-center gap-2 lg:gap-4">
                                                <div className="flex flex-col justify-center items-center text-center max-w-[720px]">
                                                    <TextBlock
                                                        couponCode={item.couponCode}
                                                        enableCouponCode={item.enableCouponCode}
                                                        eyebrow={item.eyebrowText}
                                                        eyebrowIcon={item.eyebrowIcon}
                                                        eyebrowType={item.eyebrowType}
                                                        disclaimer={
                                                            item.disclaimerText
                                                                ? item.disclaimerText
                                                                : ''
                                                        }
                                                        headlineType={item.headlineType}
                                                        headlineImage={item.headlineImage}
                                                        headline={
                                                            item.headlineText
                                                                ? item.headlineText
                                                                : ''
                                                        }
                                                        supportText={
                                                            item.textBlock ? item.textBlock : ''
                                                        }
                                                        cta={
                                                            item.callToAction
                                                                ? item.callToAction
                                                                : ''
                                                        }
                                                        buttonColor={item.buttonColor}
                                                        external={item.external}
                                                        link={carouselResolvedLink}
                                                        overlay={item.enableOverlay}
                                                        overlayColor={item.overlayColor}
                                                        alignment={item.textAlignment}
                                                        eyebrowBackgroundColor={
                                                            item.eyebrowBackgroundColor
                                                        }
                                                        eyebrowSize={item.eyebrowSize}
                                                        eyebrowTextColor={item.eyebrowTextColor}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-span-3 flex justify-center">
                                                <Image src={item.rightImage} alt="Right Image" />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        className="flex flex-col md:hidden items-center text-center px-4 gap-2"
                                        style={
                                            item.carouselBackgroundType === 'image' &&
                                            item.backgroundImageMobile &&
                                            isMobile
                                                ? {
                                                      backgroundImage: `url(${item.backgroundImageMobile})`,
                                                      backgroundSize: 'cover',
                                                      backgroundPosition: 'center'
                                                  }
                                                : {}
                                        }
                                    >
                                        <TextBlock
                                            couponCode={item.couponCode}
                                            enableCouponCode={item.enableCouponCode}
                                            eyebrow={item.eyebrowText}
                                            eyebrowIcon={item.eyebrowIcon}
                                            eyebrowType={item.eyebrowType}
                                            disclaimer={
                                                item.disclaimerText ? item.disclaimerText : ''
                                            }
                                            headlineType={item.headlineType}
                                            headlineImage={item.headlineImage}
                                            headline={item.headlineText ? item.headlineText : ''}
                                            supportText={item.textBlock ? item.textBlock : ''}
                                            cta={item.callToAction ? item.callToAction : ''}
                                            buttonColor={item.buttonColor}
                                            external={item.external}
                                            link={carouselResolvedLink}
                                            overlay={item.enableOverlay}
                                            overlayColor={item.overlayColor}
                                            alignment={item.textAlignment}
                                            eyebrowBackgroundColor={item.eyebrowBackgroundColor}
                                            eyebrowSize={item.eyebrowSize}
                                            eyebrowTextColor={item.eyebrowTextColor}
                                        />
                                        <div className="flex flex-row w-full justify-center gap-4">
                                            <div className="relative min-w-[20px] overflow-hidden w-40 h-40 align-baseline">
                                                <Image
                                                    src={
                                                        item.mobileImageLeft || item.leftImage || ''
                                                    }
                                                    alt="Left Image"
                                                />
                                            </div>
                                            <div className="relative min-w-[20px] overflow-hidden w-40 h-40 align-baseline">
                                                <Image
                                                    src={
                                                        item.mobileImageRight ||
                                                        item.rightImage ||
                                                        ''
                                                    }
                                                    alt="Right Image"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </CarouselItem>
                    )
                })}
            </CarouselContent>
            {carouselItems.length > 1 && carouselDots !== false && (
                <ContentButtonNavigation
                    buttonType="circleButton"
                    data-testid={'threecolumn-hero-carousel'}
                />
            )}
        </Carousel>
    ) : (
        <div className="hero hero-three-col flex flex-col relative pb-8 pt-8" style={bgStyle}>
            {!isMobile && !isBuilderMobile ? (
                <div className="flex flex-row gap-8 ml-auto mr-auto w-full ">
                    <div className="grid grid-cols-12 gap-8 ml-auto mr-auto w-full  items-center">
                        <div className="col-span-3 flex justify-center">
                            <Image src={leftImage} alt="Left Image" />
                        </div>
                        <div className="col-span-6 flex flex-col justify-center items-center text-center gap-2 lg:gap-4">
                            <div className="flex flex-col justify-center items-center text-center max-w-[720px]">
                                <TextBlock
                                    couponCode={couponCode}
                                    enableCouponCode={enableCouponCode}
                                    eyebrow={eyebrowText}
                                    eyebrowIcon={eyebrowIcon}
                                    eyebrowType={eyebrowType}
                                    disclaimer={disclaimerText ? disclaimerText : ''}
                                    headlineType={headlineType}
                                    headlineImage={headlineImage}
                                    headline={headlineText ? headlineText : ''}
                                    supportText={textBlock ? textBlock : ''}
                                    cta={callToAction ? callToAction : ''}
                                    buttonColor={buttonColor}
                                    external={external}
                                    link={resolvedLink}
                                    overlay={enableOverlay}
                                    overlayColor={overlayColor}
                                    alignment={textAlignment}
                                    eyebrowBackgroundColor={eyebrowBackgroundColor}
                                    eyebrowSize={eyebrowSize}
                                    eyebrowTextColor={eyebrowTextColor}
                                />
                            </div>
                        </div>
                        <div className="col-span-3 flex justify-center">
                            <Image src={rightImage} alt="Right Image" />
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className="flex flex-col md:hidden items-center text-center px-4 gap-2"
                    style={
                        backgroundType === 'image' && backgroundImageMobile && isMobile
                            ? {
                                  backgroundImage: `url(${backgroundImageMobile})`,
                                  backgroundSize: 'cover',
                                  backgroundPosition: 'center'
                              }
                            : {}
                    }
                >
                    <TextBlock
                        couponCode={couponCode}
                        enableCouponCode={enableCouponCode}
                        eyebrow={eyebrowText}
                        eyebrowIcon={eyebrowIcon}
                        eyebrowType={eyebrowType}
                        disclaimer={disclaimerText ? disclaimerText : ''}
                        headlineType={headlineType}
                        headlineImage={headlineImage}
                        headline={headlineText ? headlineText : ''}
                        supportText={textBlock ? textBlock : ''}
                        cta={callToAction ? callToAction : ''}
                        buttonColor={buttonColor}
                        external={external}
                        link={resolvedLink}
                        overlay={enableOverlay}
                        overlayColor={overlayColor}
                        alignment={textAlignment}
                        eyebrowBackgroundColor={eyebrowBackgroundColor}
                        eyebrowSize={eyebrowSize}
                        eyebrowTextColor={eyebrowTextColor}
                    />
                    <div className="flex flex-row w-full justify-center gap-4">
                        <div className="relative min-w-[20px] overflow-hidden w-40 h-40 align-baseline">
                            <Image src={mobileImageLeft || leftImage || ''} alt="Left Image" />
                        </div>
                        <div className="relative min-w-[20px] overflow-hidden w-40 h-40 align-baseline">
                            <Image src={mobileImageRight || rightImage || ''} alt="Right Image" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ThreeColumn
